import React from "react";
import MenuButton from "./MenuButton";
import "../../css/menu.css";
import AbstractMenu from "./AbstractMenu";
import SubmenuHeader from "./SubMenuHeader";
import { connect } from "react-redux";
import { I18n, Translate } from "react-redux-i18n";
import { Switch, Route } from "react-router-dom";
import Kiosk from "../../main/kiosk/Kiosk";
import { dayClose, dayOpen } from "../../js/tableMatePaid";
import auth from "../../js/auth";

class KiosksMenu extends AbstractMenu {
    state = {};

    componentDidMount() {
        //eslint-disable-next-line no-restricted-globals
        localStorage.hashBeforeRefresh = "";
    }

    render() {
        const background = "#847556";
        const cashregister = auth?.myStatus && auth?.myStatus?.restaurant_cash_registers ? auth?.myStatus?.restaurant_cash_registers.find(c => c.id === Number(localStorage.cashregister)) : null;
        return (
            <Switch>
                <Route path={"/kiosks/kiosk/:tableNumber"} render={props => <Kiosk {...props} />} />
                <Route
                    path={"/kiosks"}
                    render={props => (
                        <div className="mainMenuWrap" style={{ flexGrow: 1, display: "flex", flexFlow: "column" }}>
                            <SubmenuHeader {...this.props} header={<Translate value="admin_local.menus.pointOfSales" />} />
                            <div className="mainMenuGrid" style={{ flexGrow: 1 }}>
                                {this.props.kiosks.map(table => {
                                    return (
                                        <>
                                            <MenuButton
                                                key={table.number}
                                                href={"/kiosks/kiosk/" + table.number}
                                                background={background}
                                                myStatus={this.props.myStatus}
                                                backgroundImage={require("../../img/menu-new/kiosk-self-order.svg")}
                                                name={table.name ? table.name : "" + table.number}
                                            >
                                                <div style={{ fontSize: "60%", display: "flex", flexFlow: "column" }}>
                                                    <span>{I18n.t("admin_local.menus.bankTerminal") + ":" + (localStorage.teya_terminal || I18n.t("local.unknown"))}</span>
                                                </div>
                                            </MenuButton>
                                        </>

                                    );
                                })}
                                {cashregister && (
                                    <>
                                        <MenuButton
                                            key="open"
                                            onClick={() => dayOpen(cashregister.name)}
                                            background={background}
                                            myStatus={this.props.myStatus}
                                            name={I18n.t("admin_local.cashier_dayopen")}
                                        >
                                            <div style={{ fontSize: "60%", display: "flex", flexFlow: "column" }}>
                                                <span>{I18n.t("admin_local.menus.cashRegister") + ":" + (cashregister?.name || I18n.t("local.unknown"))}</span>
                                            </div>
                                        </MenuButton>
                                        <MenuButton
                                            key="close"
                                            onClick={() => dayClose(cashregister.name)}
                                            background={background}
                                            myStatus={this.props.myStatus}
                                            name={I18n.t("admin_local.cashier_dayclose")}
                                        >
                                            <div style={{ fontSize: "60%", display: "flex", flexFlow: "column" }}>
                                                <span>{I18n.t("admin_local.menus.cashRegister") + ":" + (cashregister?.name || I18n.t("local.unknown"))}</span>
                                            </div>
                                        </MenuButton>
                                    </>
                                )}

                            </div >
                        </div>
                    )}
                />
            </Switch>
        );
    }
}

const mapStateToProps = state => {
    return {
        restaurant_production_lines: state.rootReducer.myStatus.restaurant_production_lines,
        kiosks: state.rootReducer.kiosks ? state.rootReducer.kiosks : [],
        pointtOfSales: state.rootReducer.pointOfSales ? state.rootReducer.pointOfSales : [],
        myStatus: state.rootReducer.myStatus
    };
};

export default connect(mapStateToProps)(KiosksMenu);
